import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'

import VendorForm from '../../components/Products/vendorForm';


function mapStateToProps(state) {
    return {
        currentVendor: state.vendors.currentVendor,
        isCreating: state.vendors.isCreating,
        createError: state.vendors.createError,
        created: state.vendors.created,
        userPermissions: state.auth.userPermissions
    }

}

const validate = values => {
    const errors = {}
    if (!values.Name) {
        errors.Name = 'Required'
    }

    return errors
}

let vendorForm = reduxForm({
    form: 'vendorForm',
    validate
})(VendorForm);

export default connect(mapStateToProps)(vendorForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/vendorForm.jsx